import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Radio, Checkbox, DatePicker, Select, Space, Row, Col, Typography } from 'antd';
import { UserOutlined, PhoneOutlined, FundProjectionScreenOutlined, MailOutlined } from '@ant-design/icons';
import { SubmitCertificate } from '../services/authService';
import { useParams } from 'react-router-dom';

const { Title } = Typography;
const { Option } = Select;

const GymCertificationForm = () => {
  const [form] = Form.useForm();
  const [submitted, setSubmitted] = useState(false);

  const { category } = useParams(); 

  useEffect(() => {
    if (category) {
      form.setFieldsValue({ Category: category.toLowerCase() });
    }
  }, [category, form]);
  const onFinish = async (values) => {
    console.log('Form values:', values);
    await SubmitCertificate(values)
    setSubmitted(true);
  };

  const handleReset = () => {
    form.resetFields();
    setSubmitted(false);
  };
  

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      {!submitted ? (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{
            background: '#fff',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Title level={2} style={{ textAlign: 'center' }}>Gym Certification Form</Title>
          {/* Membership category */}
          <Row gutter={16}>
            <Col span={24}> {/* Full width */}
              <Form.Item
                name="Category"
                label="Category"
                rules={[{ required: true, message: 'Please select the Catgory!' }]} // Adjusted validation
              >
                <Select placeholder="Select a category" style={{ width: '100%' }}>
                  <Select.Option value="gold">Gold</Select.Option>
                  <Select.Option value="silver">Silver</Select.Option>
                  <Select.Option value="platinum">Platinum</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Gym Name and Address */}
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="gymName"
                label="Gym Name"
                rules={[{ required: true, message: 'Please input the gym name!' }]}
              >
                <Input placeholder="Enter the gym name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="gymAddress"
                label="Gym Address"
                rules={[{ required: true, message: 'Please input the gym address!' }]}
              >
                <Input placeholder="Enter the gym address" />
              </Form.Item>
            </Col>
          </Row>

          {/* Contact Person Information */}
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="contactPersonName"
                label="Contact Person Name"
                rules={[{ required: true, message: 'Please input the contact person name!' }]}
              >
                <Input placeholder="Enter the contact person's name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="contactPersonTitle"
                label="Contact Person Title"
                rules={[{ required: true, message: 'Please input the contact person title!' }]}
              >
                <Input placeholder="Enter the contact person's title" />
              </Form.Item>
            </Col>
          </Row>

          {/* Email and Phone */}
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Please input the email!' }]}
              >
                <Input prefix={<MailOutlined />} placeholder="Enter the contact email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="phone"
                label="Phone Number"
                rules={[{ required: true, message: 'Please input the phone number!' }]}
              >
                <Input prefix={<PhoneOutlined />} placeholder="Enter the phone number" />
              </Form.Item>
            </Col>
          </Row>

          {/* Gym Visitor Information */}
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="numMembers"
                label="Number of Gym Members"
                rules={[{ required: true, message: 'Please input the number of gym members!' }]}
              >
                <Input type="number" placeholder="Enter the number of gym members" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="avgVisits"
                label="Average Visits/Day"
                rules={[{ required: true, message: 'Please input the average visits per day!' }]}
              >
                <Input type="number" placeholder="Enter the average visits per day" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="prospectVisits"
                label="Prospect Visits/Month"
                rules={[{ required: true, message: 'Please input the number of prospect visits per month!' }]}
              >
                <Input type="number" placeholder="Enter the prospect visits per month" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="ageRange"
                label="Age Range of Gym Members"
                rules={[{ required: true, message: 'Please select the age range of gym members!' }]}
              >
                <Checkbox.Group>
                  <Space direction="horizontal" wrap>
                    <Checkbox value="13-18">13-18 Year</Checkbox>
                    <Checkbox value="18-30">18-30 Year</Checkbox>
                    <Checkbox value="30-50">30-50 Year</Checkbox>
                    <Checkbox value="50+">50+ Year</Checkbox>
                  </Space>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>

          {/* Towel Needs */}
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="numTowels"
                label="How many towels do you store on-site?"
                rules={[{ required: true, message: 'Please input the number of towels stored on-site!' }]}
              >
                <Input type="number" placeholder="Enter number of towels" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="towelTypes"
                label="Towel Types Currently in Use"
                rules={[{ required: true, message: 'Please select towel types!' }]}
              >
                <Checkbox.Group>
                  <Space direction="horizontal" wrap>
                    <Checkbox value="gymTowels">Gym Towels</Checkbox>
                    <Checkbox value="bathTowels">Bath Towels</Checkbox>
                    <Checkbox value="poolTowels">Pool Towels</Checkbox>
                    <Checkbox value="other">Other</Checkbox>
                  </Space>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="towelShrinkageGym"
                label="Monthly Shrinkage of Gym Towels"
              >
                <Input placeholder="Type n/a if not applicable" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="towelShrinkageBath"
                label="Monthly Shrinkage of Bath Towels"
              >
                <Input placeholder="Type n/a if not applicable" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="towelShrinkagePool"
                label="Monthly Shrinkage of Pool Towels"
              >
                <Input placeholder="Type n/a if not applicable" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="towelsInRotation"
                label="Number of Towels in Rotation per Day"
                rules={[{ required: true, message: 'Please input the number of towels in rotation!' }]}
              >
                <Input type="number" placeholder="Enter the number of towels in rotation" />
              </Form.Item>
            </Col>
          </Row>

          {/* In-house Laundry Information */}
          <Title level={4}>In-house Laundry Information</Title>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="numWashingMachines"
                label="How many washing machines are used in this gym?"
              >
                <Input type="number" placeholder="Enter the number of washing machines" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="washingMachineDetails"
                label="Brand and Model of Washing Machine"
              >
                <Input placeholder="Enter brand and model" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="numWashes"
                label="How many washes are done in a day?"
              >
                <Input type="number" placeholder="Enter number of washes per day" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="loadSize"
                label="Load size per wash cycle"
              >
                <Input type='number' placeholder="Enter load size" />
              </Form.Item>
            </Col>
          </Row>

          {/* Submission and Reset Buttons */}
          <Form.Item style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
              Submit
            </Button>
            <Button type="default" onClick={handleReset}>
              Reset
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <Title level={3}>Form Submitted Successfully!</Title>
        </div>
      )}
    </div>
  );
};

export default GymCertificationForm;
